import { type GQLHotspotFragment } from "@src/graphql.generated";
import { type SPFArticleWithPriceInfo } from "@src/utils/events";
import { map } from "lodash";

export const getSparePartByHotspot = (spareParts: SPFArticleWithPriceInfo[], hotspot: Pick<GQLHotspotFragment, "id">) => {
    return spareParts.find((item) => map(item.hotspots, "id").includes(hotspot.id));
};
